import { baseUrl } from '../../network'

export const inventoryItemProviderOfferingsUrl = (itemId: number) => baseUrl + `/api/inventory_items/${itemId}/provider_offerings`